import { render, staticRenderFns } from "./AccountSettingButton.vue?vue&type=template&id=dd92c1b6&scoped=true&"
import script from "./AccountSettingButton.vue?vue&type=script&lang=js&"
export * from "./AccountSettingButton.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingButton.vue?vue&type=style&index=0&id=dd92c1b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd92c1b6",
  null
  
)

export default component.exports